<template>
    <div>
        <div :id="'customToolbar'+idDefault">

            <select class="ql-font">
              <option selected>{{ $t('app.default') }}</option>
              <option value="serif">Serif</option>
              <option value="sans-serif">Sans Serif</option>
              <option value="monospace">Monospace</option>
            </select>

            <select class="ql-header">
              <option selected></option>
              <option value="1"></option>
              <option value="2"></option>
              <option value="3"></option>
              <option value="4"></option>
              <option value="5"></option>
              <option value="6"></option>
            </select>
            <button :aria-label="$t('components.text_editor.bold')" class="ql-bold"></button>
            <button :aria-label="$t('components.text_editor.italic')" class="ql-italic"></button>
            <button :aria-label="$t('components.text_editor.underline')" class="ql-underline"></button>
            <button :aria-label="$t('components.text_editor.strikethrough')" class="ql-strike"></button>

            <button :aria-label="$t('components.text_editor.align_left')" class="ql-align" value=""></button>
            <button :aria-label="$t('components.text_editor.align_center')" class="ql-align" value="center"></button>
            <button :aria-label="$t('components.text_editor.align_right')" class="ql-align" value="right"></button>
            <button :aria-label="$t('components.text_editor.justify')" class="ql-align" value="justify"></button>

            <button :aria-label="$t('components.text_editor.ordered_list')" class="ql-list" value="ordered"></button>
            <button :aria-label="$t('components.text_editor.bullet_list', { n: 1 })" class="ql-list" value="bullet"></button>
            <button :aria-label="$t('components.text_editor.bullet_list', { n: 2 })" class="ql-list" value="check"></button>

            <select class="ql-color">
            </select>

            <select class="ql-background">
            </select>

            <button :aria-label="$t('components.text_editor.insert_link')" class="ql-link"></button>

            <button @click.stop.prevent="toggleAddImage">
              <svg viewBox="0 0 18 18"
                :title="$t('components.text_editor.add_image_icon')"
                > 
                <rect class="ql-stroke" height="10" width="12" x="3" y="4"></rect> 
                <circle class="ql-fill" cx="6" cy="7" r="1"></circle> 
                <polyline class="ql-even ql-fill" points="5 12 5 11 7 9 8 10 11 7 13 9 13 12 5 12"></polyline> 
              </svg>
            </button>

            <button @click.stop.prevent="exportHtml">
              <svg  viewBox="0 0 18 18" 
                :title="$t('components.text_editor.export_html_icon')"
                >
                <path class="ql-fill ql-stroke" d="M4 9l5 5l4 -5"></path>
                <path class="ql-fill ql-stroke" d="M9 4l0 12"></path>
                <line class="ql-stroke" x1="15" x2="3" y1="16" y2="16"></line>
              </svg>  
            </button>

            <button :aria-label="$t('components.text_editor.clear_format')" class="ql-clean"></button>

            <button @click.stop.prevent="toggleInsertTag">
              <svg viewBox="0 0 24 24" stroke-width="4" fill="none" stroke-linecap="round" stroke-linejoin="round"
                :title="$t('components.text_editor.insert_tag_icon')"
                >
                <path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
                <path class="ql-stroke" d="M7.5 7.5m-1 0a1 1 0 1 0 2 0a1 1 0 1 0 -2 0"></path>
                <path class="ql-stroke" d="M3 6v5.172a2 2 0 0 0 .586 1.414l7.71 7.71a2.41 2.41 0 0 0 3.408 0l5.592 -5.592a2.41 2.41 0 0 0 0 -3.408l-7.71 -7.71a2 2 0 0 0 -1.414 -.586h-5.172a3 3 0 0 0 -3 3z"></path>
              </svg>
            </button>

          </div>
          
          <div>
            <VueEditor 
              :disabled="disableEditor"
              :id="idDefault"
              ref="vEditor"
              v-model="content" 
              :editorOptions="editorOptions"
               @focus="onEditorFocus"
              />
            <!-- Debug content -->
            <!-- <div>{{ content }}</div> -->
          </div>
        <Dialog
            :title="$t('components.text_editor.enter_image_link')"
            :visible.sync="showModalUrl"
            width="40%"
            custom-class="min-width-dialog"
            center>
            <div 
              class="overflow-x-hidden"
              >
              <el-form
                :model="form"
                ref="ruleFormUrl"
                :rules="rules"
              >
                <div class="lg:mb-2">
                  <div>
                    <label class="text-sm font-semibold text-secondary-600 block mb-1"><base-obligatory-icon/>{{$t('components.text_editor.url')}}</label>
                    <el-form-item prop="url">
                        <el-input
                            clearable
                            class="w-full"
                            v-model="form.url"
                            maxlength='1000'
                        />
                    </el-form-item>
                  </div>
                </div>
              </el-form>
            </div>
            <template slot="footer" >
              <div class="flex flex-col lg:flex-row w-full lg:w-auto items-center space-y-2 lg:space-y-0 lg:space-x-2">
                <base-button class="w-full" @click.stop.prevent="showModalUrl = false" mode="secondary-phantom-blue" :text="$t('app.cancel')"/>
                <base-button class="w-full" mode="secondary-phantom-blue" :text="$t('app.accept')" @click.stop.prevent="() => {handleImageAdded('ruleFormUrl')}"/>
              </div>
            </template>
        </Dialog>
        <Dialog
            :title="$t('components.text_editor.tag_insertion')"
            :visible.sync="showModalTag"
            width="40%"
            custom-class="min-width-dialog"
            center>
            <div 
              class="overflow-x-hidden"
              >
              <el-form
                :model="form"
                ref="ruleForm"
                :rules="rules"
              >
                <div class="lg:mb-2">
                  <div>
                    <label class="text-sm font-semibold text-secondary-600 block mb-1"><base-obligatory-icon/>{{$t('components.text_editor.tag_metadato')}}</label>
                    <el-form-item prop="tag">
                        <el-select
                          class="w-full"
                          v-model="form.tag"
                          clearable
                          filterable
                          >
                          <el-option
                            v-for="tag in tags"
                            :key="tag.Nombre"
                            :label="tag.Nombre"
                            :value="tag.Nombre">
                          </el-option>
                        </el-select>
                    </el-form-item>
                  </div>
                  <div v-if="isSelectedType2">
                    <label class="text-sm font-semibold text-secondary-600 block mb-1"><base-obligatory-icon/>{{$t('components.text_editor.link_text')}}</label>
                    <el-form-item prop="auxText">
                        <el-input
                          clearable
                          class="w-full"
                          v-model="form.auxText"
                          maxlength='100'
                        />
                    </el-form-item>
                  </div>
                  <div v-if="isSelectedType3">
                    <label class="text-sm font-semibold text-secondary-600 block mb-1"><base-obligatory-icon/>{{$t('components.text_editor.previous_text')}}</label>
                    <el-form-item prop="auxText">
                        <el-input
                          clearable
                          class="w-full"
                          v-model="form.auxText"
                          maxlength='100'
                        >
                          <template slot="append">{{tagSelected}}</template>
                        </el-input>
                    </el-form-item>
                  </div>
                </div>
              </el-form>
            </div>
            <template slot="footer" >
              <div class="flex flex-col lg:flex-row w-full lg:w-auto items-center space-y-2 lg:space-y-0 lg:space-x-2">
                <base-button class="w-full" @click.stop.prevent="showModalTag = false" mode="secondary-phantom-blue" :text="$t('app.cancel')"/>
                <base-button class="w-full" mode="secondary-phantom-blue" :text="$t('app.accept')" @click.stop.prevent="() => {insertTag('ruleForm')}"/>
              </div>
            </template>
        </Dialog>
    </div>
</template>
<script>
import { VueEditor, Quill } from 'vue2-editor'
import { Dialog } from 'element-ui'
import { i18n } from '@/i18n'

var FontStyle = Quill.import('attributors/style/font')
FontStyle.whitelist = ['serif', 'sans-serif', 'monospace']
Quill.register(FontStyle, true)

export default {
  name: 'text-editor',
  props: {
    contentDefault: {
      type: String,
      default: `<h1>${i18n.t('components.text_editor.rich_text_editor')}</h1>`
    },
    idDefault: {
      type: String,
      default: 'texteditor1'
    },
    tags: {
      default: [
        {
          Nombre: i18n.t('components.text_editor.example'),
          Tag: i18n.t('components.text_editor.example_tag'),
          idTipo: 1,
        }, 
      ],
    },
    disableEditor: {
      type: Boolean,
      default: false,
    }
  },
  components: {
    VueEditor,
    Dialog,
  },
  data () {
    return {
      editorOptions: {
        modules: {
          toolbar: {
            container: '#customToolbar' + this.idDefault,
          }
        },
      },
      editorFocused: null,
      showModalUrl: false,
      showModalTag: false,
      content: '',
      form: {
        url: '',
        tag: '',
        auxText: '',
      },
      rules: {
        tag: [
          {
            required: true,
            message: i18n.t('validation.complete'),
            trigger: 'blur'
          },
          {
            required: true,
            message: i18n.t('validation.complete'),
            trigger: 'change'
          }
        ],
        auxText: [
          {
            required: true,
            message: i18n.t('validation.complete'),
            trigger: 'blur'
          },
        ],
        url: [
          {
            required: true,
            message: i18n.t('validation.complete'),
            trigger: 'blur'
          },
        ]
      }
    }
  },
  created () {
    this.content = this.contentDefault
  },
  watch: {
    showModalUrl (newValue, oldValue) {
      if (!newValue) {
        this.form.url = ''
      }
    },
    showModalTag (newValue, oldValue) {
      if (!newValue) {
        this.form.tag = ''
        this.form.auxText =''
      }
    },
    contentDefault (newValue, oldValue) {
      this.content = newValue
    },
  },
  computed: {
    isSelectedType2 () {
      if (!this.form.tag) return false
      return this.tags.filter(x => x.Nombre === this.form.tag)[0].idTipo === 2
    },
    isSelectedType3 () {
      if (!this.form.tag) return false
      return this.tags.filter(x => x.Nombre === this.form.tag)[0].idTipo === 3
    },
    tagSelected () {
      if (!this.form.tag) return ''
      return this.tags.filter(x => x.Nombre === this.form.tag)[0].Tag
    }
  },
  methods: {
    onEditorFocus (quill) {    
      this.editorFocused = quill 
    }, 
    toggleAddImage () {
      if (this.disableEditor) return
      if (!this.editorFocused) {
        this.doFeedback(i18n.t('feedback.info.place_cursor_image_msg'), 'info')
        return
      }
      this.showModalUrl = !this.showModalUrl
    },
    handleImageAdded (ruleForm) {
      if (this.disableEditor) return
      try {
        this.$refs[ruleForm].validate(async valid => {
          if (valid) {
            this.showModalUrl = false
            this.editorFocused.insertEmbed(
              this.editorFocused.getSelection(true).index, 
              'image', 
              this.form.url, 
              '')
          } else {
            this.doFeedback(i18n.t('feedback.error.process_data_error'))
          }
        })
      } catch (error) {
        this.doFeedback()
      }
    },
    getContent () {
      return this.content
    },
    getContentDifferent () {
      if (this.content === this.contentDefault) {
        return null
      }
      return this.content
    },
    exportHtml: async function () {
      if (this.disableEditor) return
      try {
        const blob = new Blob([this.content], { type: 'text/html', encoding: 'UTF-8' })
        const link = document.createElement('a')
        link.href = window.URL.createObjectURL(blob)
        let filename = `${i18n.t('components.text_editor.body_mail')}.html`
        filename = decodeURI(filename)
        link.download = filename
        link.click()
      } catch (error) {
        console.error(error)
        if (error.response?.data) {
          const errorText = await error.response.data.text()
          this.doFeedback(errorText)
        } else {
          this.doFeedback()
        }
      } finally {
        this.isLoadedExcel = true
      }
    },
    toggleInsertTag () {
      if (this.disableEditor) return
      if (!this.editorFocused) {
        this.doFeedback(i18n.t('feedback.info.place_cursor_tag_msg'), 'info')
        return
      }
      this.showModalTag = !this.showModalTag
    },
    insertTag: async function (ruleForm) {
      if (this.disableEditor) return
      try {
        this.$refs[ruleForm].validate(async valid => {
          if (valid) {
            this.showModalTag = false
            if (this.isSelectedType2) {
              this.editorFocused.insertText(
                this.editorFocused.getSelection(true).index, 
                this.form.auxText, 
                'link', 
                this.tagSelected)
              return
            }
            if (this.isSelectedType3) {
              const actualTag = this.tags.filter(x => x.Nombre === this.form.tag)[0]
              this.editorFocused.insertText(
                this.editorFocused.getSelection(true).index, 
                actualTag.TagIni + this.form.auxText + ' ' + this.tagSelected + actualTag.TagFin)
              return
            }
            this.editorFocused.insertText(
              this.editorFocused.getSelection(true).index, 
              this.tagSelected)
          } else {
            this.doFeedback(i18n.t('feedback.error.process_data_error'))
          }
        })
      } catch (error) {
        this.doFeedback()
      }
    },
  }
}
</script>
